import TCFConsentTable from './TCFConsentTable'

export default TCFConsentTable
